 //--
import request from "../../../core/wrappers/axios-wrapper";
import { ApiURL } from "../../../types/constants/apiUrls/api-urls";
import { RequestType } from "../../../types/enums/request-enums";
 //#region comment metod


 const PostDesignCollectiveFilterData =(data: any)   =>
request({
  url: ApiURL.Command.PostDesignCollectiveFilterData,

  method: RequestType.POST,
  data,
});

const PutDesignCollectiveStatusUpdate =(data: any): Promise<any>    =>
request({
  url: ApiURL.Command.PutDesignCollectiveStatusUpdate,

  method: RequestType.PUT,
  data,
});
const PostTransferCargoData =(data: any): Promise<any>    =>
request({
  url: ApiURL.Command.PostTransferData,
  method: RequestType.POST,
  data,
});


const DesignCollectiveCommand = {
    PostDesignCollectiveFilterData,
    PutDesignCollectiveStatusUpdate,
    PostTransferCargoData,
  };
  
  export default DesignCollectiveCommand;